var WagerTypes = {
  WPS: { name: "wps" },
  WIN: { name: "Win", id: 0 },
  PLACE: { name: "Place", id: 1 },
  SHOW: { name: "Show", id: 2 },
  DAILYDOUBLE: { name: "DailyDouble", id: 7 },
  EXACTA: { name: "Exacta", id: 8 },
  TRIFECTA: { name: "Trifecta", id: 9 },
  QUINELLABOX: { name: "QuinellaBox", id: 11 },
  QUINELLA: { name: "Quinella", id: 12 },
  SUPERFECTA: { name: "Superfecta", id: 13 },
  EXACTABOX: { name: "ExactaBox", id: 21 },
  TRIFECTABOX: { name: "TrifectaBox", id: 22 },
  PICK3: { name: "Pick3", id: 23 },
  PICK4: { name: "Pick4", id: 24 },
  PICK6: { name: "Pick6", id: 25 },
  SUPERFECTABOX: { name: "SuperfectaBox", id: 26 },
  // WINPARLAY  : { name: "exacta", id: 27
  // PLACEPARLAY: { name: "exacta", id: 28
  // SHOWPARLAY : { name: "exacta", id: 29
  // WINRR   : { name: "exacta", id: 30
  // PLACERR : { name: "exacta", id: 31
  // SHOWRR  : { name: "exacta", id: 32
  HOUSEQ: { name: "HouseQ", id: 33 },
  HOUSEQBOX: { name: "HouseQBox", id: 34 },
  PICK5: { name: "Pick5", id: 36 },
  PICK7: { name: "Pick7", id: 37 },
  PICK8: { name: "Pick8", id: 38 },
  PICK9: { name: "Pick9", id: 39 },
  PICK10: { name: "Pick10", id: 40 },
  PICK11: { name: "Pick11", id: 41 },
  PICK12: { name: "Pick12", id: 42 },
  // EXACTAREVERSE: { name: "exacta", id: 43
  HIGH5: { name: "High5", id: 44 },
  OMNI: { name: "Omni", id: 45 },
  GRANDSLAM: { name: "GrandSlam", id: 46 },
};

export default WagerTypes;
